import BaseGraphQLClient from '@/api/graphql/BaseGraphQLClient';

// Shared instance of the Gaia GraphQL client
const GaiaGraphQLClient = (options = {}) => new BaseGraphQLClient({
  ...options,
  baseDomain: import.meta.env.VITE_GRAPHQL_GAIA_DOMAIN,
});

export default GaiaGraphQLClient;
